import { useViewport } from '@lamimed/pantheon';
import Head from 'next/head';

import { Header } from 'components/Header';
import { SectionWrapper } from 'components/wrappers/SectionWrapper';

import { GetInTouch } from '../Home/containers/GetInTouch';

const GetInTouchTemplate: React.FC = () => {
  const { greaterThan } = useViewport();

  return (
    <>
      <Head>
        <title key="title">
          Lami: visite mediche, videoconsulti online e assistenza domiciliare
        </title>

        <meta
          key="description"
          name="description"
          content="Scopri i servizi di consulenza medica di Lamimed e contatta i migliori esperti comodamente da casa tua. Prenota subito la tua video visita."
        />
      </Head>

      <Header />

      <SectionWrapper
        id="get-in-touch"
        backgroundColor="neutral_extra_light"
        paddingTop={greaterThan('tablet') ? 'xxlarge' : 'xlarge'}
      >
        <GetInTouch />
      </SectionWrapper>
    </>
  );
};

export default GetInTouchTemplate;
